// extracted by mini-css-extract-plugin
module.exports = {"title":"index-title-1se0l","container":"index-container-2dukf","card":"index-card-_RcHT"};